import React from 'react';
import { Charge } from '../core/_models';

interface Props {
  charge: Charge | null;
  show: boolean;
  onHide: () => void;
  onConfirm: (chargeId: string, reason: string) => void;
  isLoading?: boolean;
}

export const ChargeRefundModal: React.FC<Props> = ({ charge, show, onHide, onConfirm, isLoading }) => {
  const [reason, setReason] = React.useState('');

  if (!show || !charge) return null;

  return (
    <>
      <div className='modal fade show d-block' tabIndex={-1} role='dialog' aria-modal='true'>
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          <div className='modal-content'>
            <div className='modal-header'>
              <h2 className='fw-bolder'>Solicitar Estorno</h2>
              <div className='btn btn-icon btn-sm btn-active-icon-primary' onClick={onHide}>
                <i className='bi bi-x fs-1'></i>
              </div>
            </div>

            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              {charge.payment_method === 'BOLETO' ? (
                <div className='notice d-flex bg-light-info rounded border-info border border-dashed mb-9 p-6'>
                  <i className='bi bi-info-circle fs-2tx text-info me-4'></i>
                  <div className='d-flex flex-stack flex-grow-1'>
                    <div className='fw-bold'>
                      <div className='fs-6 text-gray-700'>
                        Não é possível estornar cobranças pagas via boleto bancário automaticamente. Para reembolsar o cliente, realize a transferência manualmente.
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className='notice d-flex bg-light-warning rounded border-warning border border-dashed mb-9 p-6'>
                  <i className='bi bi-exclamation-triangle fs-2tx text-warning me-4'></i>
                  <div className='d-flex flex-stack flex-grow-1'>
                    <div className='fw-bold'>
                      <h4 className='text-gray-900 fw-bolder'>Atenção</h4>
                      <div className='fs-6 text-gray-700'>
                        O estorno será processado diretamente no gateway de pagamento (Asaas/Lekko). Esta ação é irreversível.
                      </div>
                    </div>
                  </div>
                </div>
              )}

              <div className='d-flex flex-column mb-8'>
                <label className='fs-6 fw-bold mb-2'>Detalhes da Fatura</label>
                <div className='d-flex flex-stack bg-light rounded p-4'>
                  <span className='fw-bolder text-gray-800'>{charge.client?.user?.name || charge.client?.nameResponsible || charge.client_name || 'Desconhecido'}</span>
                  <span className='fw-bolder text-gray-800 text-dark'>R$ {Number(charge.gross_value).toFixed(2).replace('.', ',')}</span>
                </div>
              </div>

              {charge.payment_method !== 'BOLETO' && (
                <div className='d-flex flex-column mb-8'>
                  <label className='fs-6 fw-bold mb-2'>Motivo do Estorno <span className='text-danger'>*</span></label>
                  <textarea
                    className='form-control form-control-solid'
                    rows={3}
                    placeholder='Informe o motivo do estorno para registro no histórico...'
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  ></textarea>
                </div>
              )}

              <div className='text-center pt-15'>
                <button type='reset' className='btn btn-light me-3' onClick={onHide}>
                  {charge.payment_method === 'BOLETO' ? 'Fechar' : 'Cancelar'}
                </button>
                {charge.payment_method !== 'BOLETO' && (
                  <button
                    type='submit'
                    className='btn btn-warning'
                    onClick={() => onConfirm(charge.id, reason)}
                    disabled={!reason.trim() || isLoading}
                  >
                    {isLoading ? (
                      <span className='indicator-progress' style={{ display: 'block' }}>
                        Aguarde... <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                      </span>
                    ) : (
                      <span className='indicator-label'>Confirmar Estorno</span>
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='modal-backdrop fade show'></div>
    </>
  );
};
